import React from 'react';
import EditUnitPage from './EditUnitPage';
import { connect } from 'react-redux';
import unitsActions from '../../../../../actions/units.actions';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';

class EditUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unit: {},
      loading: false,
      isSubmitting: false,
      getUnitError: {},
      errors: '',
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.units.unit !== prevState.unit) {
      state.unit = nextProps.units.unit;
    }
    if (nextProps.units.loading !== prevState.loading) {
      state.loading = nextProps.units.loading;
    }
    if (nextProps.units.getUnitError !== prevState.getUnitError) {
      state.getUnitError = nextProps.units.getUnitError;
    }
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    const { unitId } = this.props.match.params;
    await this.props.getSpecificUnit(unitId);
  }

  onEditUnit = (params) => {
    const { unitId } = this.props.match.params;
    this.setState(
      { isSubmitting: true, errors: '' },
      async () =>
        await this.props
          .editUnit(unitId, params)
          .then(() => this.props.history.push('/configure/units'))
          .catch((msg) => this.setState({ isSubmitting: false, errors: msg })),
    );
  };
  render() {
    const { loading } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return <EditUnitPage {...this.state} onEditUnit={this.onEditUnit} />;
  }
}

function mapStateToProps(state) {
  return {
    units: state.units,
  };
}

export default connect(mapStateToProps, unitsActions)(EditUnit);
